import React from 'react';
interface CTAButtonProps {
  href: string;
  children: React.ReactNode;
  className?: string;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
}
export function CTAButton({
  href,
  children,
  className = '',
  onClick
}: CTAButtonProps) {
  return <a href={href} onClick={e => {
    if ((window as any).fbq) {
      ;
      (window as any).fbq('track', 'AddToCart');
    }
    if (onClick) onClick(e);
  }} className={`bg-gradient-to-br from-[#FF8C00] to-[#FFD700] text-white border-none p-4 text-lg font-bold rounded-full cursor-pointer transition-all duration-400 ease-[cubic-bezier(0.25,0.8,0.25,1)] shadow-[0_8px_20px_rgba(255,140,0,0.4)] block mx-auto w-full text-center uppercase tracking-wide animate-pulse-big hover:translate-y-[-3px] hover:scale-[1.02] hover:shadow-[0_8px_20px_rgba(255,140,0,0.6)] hover:animate-none ${className}`} data-id="element-51">
      {children}
    </a>;
}